import moment from "moment";

export const formatTimeStamp = (newTimeStamp: string) => {
  const timestamp = parseInt(newTimeStamp, 10) * 1000;
  const dateStr = moment(timestamp).format("DD/MM/YYYY hh:mm:ss");
  return dateStr;
};

export const formatDate = (newTimeStamp: string, format?: string) => {
  const timestamp = parseInt(newTimeStamp, 10) * 1000;
  const dateStr = moment(timestamp).format(format ?? "DD/MM/YYYY");
  return dateStr;
};

export const formatTime = (newTimeStamp: string) => {
  const timestamp = parseInt(newTimeStamp, 10) * 1000;
  const dateStr = moment(timestamp).format("hh:mm:ss");
  return dateStr;
};

export const fTimeHHMM = (newTimeStamp: string) => {
  const timestamp = parseInt(newTimeStamp, 10);
  const dateStr = moment.unix(timestamp).format("HH:mm");
  return dateStr;
};

type IFormat = "YYYY-MM-DD hh:mm:ss" | "HH:mm" | "hh:mm:ss" | "DD/MM/YYYY" | "YYYY-MM-DD" | "DD/MM/YYYY HH:mm:ss";

interface IFormatTimeStamp {
  unix: string;
  format?: IFormat;
}

export const formatUnix = ({ unix, format = "DD/MM/YYYY HH:mm:ss" }: IFormatTimeStamp): string => {
  if (!unix) return "";

  let epoch = parseInt(unix.toString(), 10);

  // If 10-digit → seconds → convert to ms
  if (unix.toString().length === 10) {
    epoch = epoch * 1000;
  }

  const d = moment(epoch);

  if (Number.isNaN(epoch) || !d.isValid()) {
    // eslint-disable-next-line no-console
    console.error("Invalid Timestamp", { timestamp: epoch, format });
    return "";
  }

  return d.format(format);
};
